import { createSlice } from '@reduxjs/toolkit';
import getAdapter from './getAdapter';

const chassisPoolsAdapter = getAdapter();

const chassisPoolsSlice = createSlice({
  name: 'chassisPools',
  initialState: chassisPoolsAdapter.getInitialState(),
  reducers: {
    setChassisPools: (state, { payload: { chassisPools } }) => {
      chassisPoolsAdapter.setAll(state, chassisPools);
    },
  },
});

const selectors = chassisPoolsAdapter.getSelectors(({ chassisPools }) => chassisPools);

export const getChassisPools = (state) => selectors.selectAll(state);

export const {
  setChassisPools
} = chassisPoolsSlice.actions;

export default chassisPoolsSlice.reducer;